"use client"

import { Trans } from "@lingui/react/macro"
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@rarible_int/anaconda_ui_components"

interface Props {
  children: React.ReactNode
}

export function ComingSoon({ children }: Props) {
  return (
    <Tooltip>
      <TooltipTrigger className="cursor-not-allowed" asChild>
        {children}
      </TooltipTrigger>
      <TooltipContent>
        <Trans>Coming soon</Trans>
      </TooltipContent>
    </Tooltip>
  )
}
